<script>
import {
  CdrLink,
  CdrList,
  IconPrint,
  IconFacebook,
  IconPinterest,
} from '@rei/cedar';

export default {
  name: 'SocialShare',
  components: {
    CdrLink,
    CdrList,
    IconPrint,
    IconFacebook,
    IconPinterest,
  },
  props: {
    articleTitle: {
      type: String,
      required: true,
      default: '',
    },
    articleUri: {
      type: String,
      required: true,
      default: '',
    },
  },
  data: () => ({
    baseClassName: 'social-share',
  }),
};
</script>

<template>
  <cdr-list
    :class="`${baseClassName}`"
    modifier="inline"
  >
    <li>
      <cdr-link
        tag="button"
        type="button"
        class="btn-link"
        onclick="window.print()"
      >
        <icon-print />
        <span class="social-share__text-sr-only">Print</span>
      </cdr-link>
    </li>
    <li>
      <cdr-link
        :href="`https://www.facebook.com/sharer/sharer.php?u=https://www.rei.com${articleUri}cm_mmc=sm_fb-_-share&picture=https://www.rei.com/assets/img/seo/evergreen/rei-og.jpg&name=${articleTitle}`"
        class="link_stag well-sm"
        target="_blank"
      >
        <icon-facebook />
        <span :class="`${baseClassName}__text-sr-only`">Facebook</span>
      </cdr-link>
    </li>
    <li>
      <cdr-link
        :href="`https://pinterest.com/pin/create/button/?url=https://www.rei.com${articleUri}?cm_mmc=sm_pin-_-share&media=https://www.rei.com/assets/img/seo/evergreen/rei-og.jpg&description=${articleTitle}`"
        class="link_stag well-sm"
        target="_blank"
      >
        <icon-pinterest />
        <span :class="`${baseClassName}__text-sr-only`">Pinterest</span>
      </cdr-link>
    </li>
  </cdr-list>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

  $baseClassName: 'social-share';

.#{$baseClassName} {
  .#{$baseClassName}__text-sr-only {
    @include cdr-display-sr-only;
  }
}
</style>
